module.exports = __webpack_public_path__ + "img/ione2.23c875d3.png";